import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <circle
      transform="scale(1.5 1.5)"
      cx="8"
      cy="8.08333"
      r="5.25"
      stroke="#0D47A1"
      strokeWidth="1.5"
    />
    <path
      d="M8.75 5.58333C8.75 5.16912 8.41421 4.83333 8 4.83333C7.58579 4.83333 7.25 5.16912 7.25 5.58333L8.75 5.58333ZM7.25 9.58333C7.25 9.99755 7.58579 10.3333 8 10.3333C8.41421 10.3333 8.75 9.99755 8.75 9.58333L7.25 9.58333ZM7.25 5.58333L7.25 9.58333L8.75 9.58333L8.75 5.58333L7.25 5.58333Z"
      fill={fill}
      transform="scale(1.5 1.5)"
    />
    <path
      d="M8.66669 2.5C9.0809 2.5 9.41669 2.16421 9.41669 1.75C9.41669 1.33579 9.0809 1 8.66669 1L8.66669 2.5ZM7.33335 1C6.91914 1 6.58335 1.33579 6.58335 1.75C6.58335 2.16421 6.91914 2.5 7.33335 2.5L7.33335 1ZM8.66669 1L7.33335 1L7.33335 2.5L8.66669 2.5L8.66669 1Z"
      fill={fill}
      transform="scale(1.5 1.5)"
    />
    <path
      d="M12.8636 1.88633C12.5707 1.59344 12.0959 1.59344 11.803 1.88633C11.5101 2.17923 11.5101 2.6541 11.803 2.94699L12.8636 1.88633ZM12.4696 3.61366C12.7625 3.90655 13.2374 3.90655 13.5303 3.61366C13.8232 3.32077 13.8232 2.84589 13.5303 2.553L12.4696 3.61366ZM11.803 2.94699L12.4696 3.61366L13.5303 2.553L12.8636 1.88633L11.803 2.94699Z"
      fill={fill}
      transform="scale(1.5 1.5)"
    />
    <circle
      transform="scale(1.5 1.5)"
      cx="8"
      cy="8.33333"
      r="1.25"
      fill={fill}
    />
  </g>
);

export default Icon;
